import React from 'react';

import { BasketState } from '@front/common/src/ducks/common/basket';
import colors from '@front/common/src/utils/colors';
import { formatPrice, formatPricePerHour, formatPricePerMonth } from '@front/common/src/utils/formatting';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';
import { Price } from '@front/customer/src/types/prices';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import TextButton from '@front/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

type NotMemberWithSpotPrestationProps = {
  reduction: Price;
  getMoreInfoPress: () => void;
  duration: BasketState['duration'];
};

const NotMemberWithSpotPrestation = ({ reduction, getMoreInfoPress, duration }: NotMemberWithSpotPrestationProps) => {
  const membershipMonthlyPrice = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()].monthlyPrice;

  const formattedPrice = duration
    ? formatPrice(reduction.price)
    : formatPricePerHour(reduction.hourly_price, { precision: 0 });

  return (
    <span>
      <Text.SMBold>{t('.cleaning.spot.is_not_yet_member.text_1')}</Text.SMBold>
      <Text.SMBold color={colors.pink120}>{` ${formattedPrice} `}</Text.SMBold>
      <Text.SMBold>{`${t('.cleaning.spot.is_not_yet_member.text_2')} `}</Text.SMBold>
      <Text.SM>{`${t('.cleaning.spot.is_not_yet_member.text_3', {
        pricePerMonth: formatPricePerMonth(membershipMonthlyPrice),
      })} `}</Text.SM>
      <TextButton size='sm' onClick={getMoreInfoPress}>
        {t('.more_info_link')}
      </TextButton>
    </span>
  );
};

export default NotMemberWithSpotPrestation;
